// Metadados visuais das etiquetas (flags) de atendimento. Slug = etiqueta no
// Chatwoot (aplicada pelo bot de triagem ou na mão pelo atendente).
export interface FlagMeta {
  label: string;
  cls: string; // classes de badge (fundo + texto)
  dot: string; // classe de cor pro pontinho
}

export const FLAG_META: Record<string, FlagMeta> = {
  tecnico: {
    label: 'Suporte técnico',
    cls: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
    dot: 'bg-blue-500',
  },
  financeiro: {
    label: 'Financeiro',
    cls: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
    dot: 'bg-amber-500',
  },
  'novo-usuario': {
    label: 'Novo usuário',
    cls: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
    dot: 'bg-emerald-500',
  },
  'compra-brinco': {
    label: 'Compra de brinco',
    cls: 'bg-yellow-500/15 text-yellow-700 dark:text-yellow-400',
    dot: 'bg-yellow-500',
  },
  'compra-leitor': {
    label: 'Compra de leitor',
    cls: 'bg-violet-500/15 text-violet-600 dark:text-violet-400',
    dot: 'bg-violet-500',
  },
  'nao-identificado': {
    label: 'Não identificado',
    cls: 'bg-slate-500/15 text-slate-500 dark:text-slate-400',
    dot: 'bg-slate-500',
  },
  'triagem-incompleta': {
    label: 'Triagem incompleta',
    cls: 'bg-red-500/15 text-red-600 dark:text-red-400',
    dot: 'bg-red-500',
  },
};

export function flagMeta(slug: string): FlagMeta {
  return (
    FLAG_META[slug] || {
      label: slug,
      cls: 'bg-muted text-text-secondary',
      dot: 'bg-text-tertiary',
    }
  );
}

// Etiquetas que aparecem no filtro rápido da lista (as principais da triagem).
export const FILTER_FLAGS = [
  'tecnico',
  'financeiro',
  'compra-brinco',
  'compra-leitor',
  'novo-usuario',
  'triagem-incompleta',
];
